import { Grid, Typography } from "@mui/material";
import bannerImage24 from "../../../../../src/assets/image/most-efficient/original/me_2024.svg";
import bannerImage25 from "../../../../../src/assets/image/most-efficient/original/me_2025.svg";
import bannerImage26 from "../../../../../src/assets/image/most-efficient/original/me_2026.svg";
import bannerImage27 from "../../../../../src/assets/image/most-efficient/original/me_2027.svg";
import bannerImage28 from "../../../../../src/assets/image/most-efficient/original/me_2028.svg";
import bannerImage29 from "../../../../../src/assets/image/most-efficient/original/me_2029.svg";
import bannerImage30 from "../../../../../src/assets/image/most-efficient/original/me_2030.svg";
import { customColors, CustomColors } from "../../../styles/CustomColors";
import { Box } from "@mui/system";
interface BannerProps {
  colors?: CustomColors;
}

const bannerImage = () => {
  switch(import.meta.env.VITE_MOSTEFFICIENTYEAR)
  {
    case "2024": return (<img src={bannerImage24} alt={"ENERGY STAR logo and Most Efficient "+ import.meta.env.VITE_MOSTEFFICIENTYEAR + " www.energystar.gov text"} style={{ maxWidth: "100%", padding: 0, margin: 0, }} />);
    case "2025": return (<img src={bannerImage25} alt={"ENERGY STAR logo and Most Efficient "+ import.meta.env.VITE_MOSTEFFICIENTYEAR + " www.energystar.gov text"} style={{ maxWidth: "100%", padding: 0, margin: 0, }} />);;
    case "2026": return (<img src={bannerImage26} alt={"ENERGY STAR logo and Most Efficient "+ import.meta.env.VITE_MOSTEFFICIENTYEAR + " www.energystar.gov text"} style={{ maxWidth: "100%", padding: 0, margin: 0, }} />);;
    case "2027": return (<img src={bannerImage27} alt={"ENERGY STAR logo and Most Efficient "+ import.meta.env.VITE_MOSTEFFICIENTYEAR + " www.energystar.gov text"} style={{ maxWidth: "100%", padding: 0, margin: 0, }} />);;
    case "2028": return (<img src={bannerImage28} alt={"ENERGY STAR logo and Most Efficient "+ import.meta.env.VITE_MOSTEFFICIENTYEAR + " www.energystar.gov text"} style={{ maxWidth: "100%", padding: 0, margin: 0, }} />);;
    case "2029": return (<img src={bannerImage29} alt={"ENERGY STAR logo and Most Efficient "+ import.meta.env.VITE_MOSTEFFICIENTYEAR + " www.energystar.gov text"} style={{ maxWidth: "100%", padding: 0, margin: 0, }} />);;
    case "2030": return (<img src={bannerImage30} alt={"ENERGY STAR logo and Most Efficient "+ import.meta.env.VITE_MOSTEFFICIENTYEAR + " www.energystar.gov text"} style={{ maxWidth: "100%", padding: 0, margin: 0, }} />);;
  }
}

const Banner: React.FC<BannerProps> = ({ colors = customColors }) => {
  return (
    <Grid
      container
      direction={{ xs: "column-reverse", sm: "column-reverse", md: "row" }}
      marginBottom={{ xs: "1.875rem", sm: "1.875rem", md: "4rem" }}
      fontFamily="Roboto, Helvetica, Arial, sans-serif"
      sx={{
        backgroundColor: colors.skyBlueBg,
      }}
    >
      {/* Text section  */}
      <Grid
        item
        xs={12}
        sm={6}
        md={6}
        padding={{ xs: "1.5rem", md: "1.875rem" }}
      >
        <Box
          role="banner"
          sx={{
            backgroundColor: colors.skyBlueBg,
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            aria-label="The Year’s Best of ENERGY STAR for Energy Efficiency and Innovation"
            variant="h2"
            fontSize="1.88rem"
            fontWeight="700"
            lineHeight="1.1"
            marginBottom="1.5rem"
            fontFamily="Roboto, Helvetica, Arial, sans-serif"
            display="block"
          >
            The Year’s Best of ENERGY STAR for Energy Efficiency and Innovation
          </Typography>
          <Typography
            aria-label="WHEN ONLY THE BEST WILL DO"
            variant="h3"
            fontSize="1.95rem"
            fontWeight="700"
            lineHeight="1.1"
            marginBottom="1.5rem"
            sx={{ textTransform: "capitalize" }}
          >
            WHEN ONLY THE BEST WILL DO.
          </Typography>
          <Typography variant="body1" lineHeight="1.5" marginBottom="0">
            Looking for the ENERGY STAR label is a simple way to save you money
            and protect the environment. Now EPA introduces ENERGY STAR Most
            Efficient {import.meta.env.VITE_MOSTEFFICIENTYEAR}, a distinction that recognizes products that deliver
            cutting edge energy efficiency along with the latest in
            technological innovation. It is an award that truly represents the
            best of ENERGY STAR.
          </Typography>
        </Box>
      </Grid>
      {/* * Image section  */}
      <Grid item xs={12} md={6} sx={{ maxHeight: "27rem", display:{xs:"inline", md:"block"}, minHeight:{xs:"38vw", md:"21rem"}, overflow:"clip"}}>
        <div style={{margin:'20px', padding:'10px 20px 12px 20px', background:'white', overflow:'auto'}}>
         {bannerImage()}        
        </div>
      </Grid>
    </Grid>
  );
};

export default Banner;
